import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tir-pm-kanban-column" }
const _hoisted_2 = { class: "tir-pm-kanban-column__header" }
const _hoisted_3 = { class: "tir-pm-kanban-column__indicators-wrap" }
const _hoisted_4 = { class: "tir-pm-kanban-column__count-card" }
const _hoisted_5 = { class: "tir-pm-kanban-column__tools-wrap" }
const _hoisted_6 = { class: "tir-pm-kanban-column__list-card-area" }

import { PropType } from "vue";
import TirPmDraggable from "./TirPmDraggable.vue";

// const slots = useSlots();

// /**
//  * Есть ли слот для иконки слева
//  */
// const isLeftAddon = computed(() => slots && slots.leftAddon && slots.leftAddon());
// /**
//  * Есть ли слот для кнотролов, кнопок справа
//  */
// const isRightControls = computed(() => slots && slots.rightControls && slots.rightControls());
// /**
// //  * Есть ли конент
// //  */
// // const contentSlot = computed(() => slots && slots.content && slots.content());
// // console.log(contentSlot.value);

// let fileUpload = ref(null);
// /**
//  * Пропсы
//  */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmKanbanColumn',
  props: {
  /**
   * Имя файла
   */
  fileName: {
    type: String as PropType<string | null | undefined>,
    default: "File name",
  },
  /**
   * Процент загрузки
   */
  percent: {
    type: String as PropType<string | null | undefined>,
    default: null,
  },
  /**
   * Размер файла
   */
  fileSize: {
    type: String as PropType<string | null | undefined>,
    default: null,
  },
  /**
   * Дата загрузки
   */
  dateUpload: { type: String as PropType<string | null | undefined>, default: null },
  /**
   * Список предупреждений и состояний
   */
  stateUploadList: {
    type: Object as PropType<Array<{ variant: "default" | "error"; text: string }>>,
    default() {
      return [];
    },
  },
  withBorder: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "indicator"),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "count")
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "tools")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "cards")
    ])
  ]))
}
}

})